<template>
  <div>
    <div class="page-wrapper">
      <!-- Preloader -->
      <div class="preloader">
        <div class="icon"></div>
      </div>

      <!-- Main Header -->
      <header class="main-header header-style-one">
        <!-- Header Top -->
        <div class="header-top">
          <div class="auto-container">
            <div class="inner clearfix">
              <div class="top-left clearfix">
                <ul class="info clearfix">
                  <li><div class="change-language">
                      <div class="language dropdown">
                        <a
                          class="dropdown-toggle clearfix"
                          id="lang-dropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          href="#"
                        >
                          <span class="icon fa fa-globe"></span>{{ $t('header.language') }}
                          <span class="arrow flaticon-cheveron-down"></span>
                        </a>
                        <ul class="dropdown-menu style-one" aria-labelledby="lang-dropdown">
                          <li>
                            <a href="#" @click="changerLangue('AR')">{{ $t('header.languages.arabic') }}</a>
                          </li>
                          <li>
                            <a href="#" @click="changerLangue('FR')">{{ $t('header.languages.french') }}</a>
                          </li>
                          <li>
                            <a href="#" @click="changerLangue('EN')">{{ $t('header.languages.english') }}</a>
                          </li>
                        </ul>
                      </div>
                    </div></li>
                  <li>
                    <a href="tel:812-070-3692">
                      <span class="icon fa fa-phone-alt"></span> {{ $t('header.support') }} &nbsp;{{ $t('header.phone') }}
                    </a>
                  </li>
                  <li>
                    <a href="mailto:associationdaideauxhandicapesh@gmail.com">
                      <span class="icon fa fa-envelope-open"></span> {{ $t('header.email') }}
                    </a>
                  </li>
                </ul>
              </div>

              <div class="top-right clearfix">
                <!-- <ul class="info clearfix">
                  <li>
                    <div class="change-language">
                      <div class="language dropdown">
                        <a
                          class="dropdown-toggle clearfix"
                          id="lang-dropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          href="#"
                        >
                          <span class="icon fa fa-globe"></span>{{ $t('header.language') }}
                          <span class="arrow flaticon-cheveron-down"></span>
                        </a>
                        <ul class="dropdown-menu style-one" aria-labelledby="lang-dropdown">
                          <li>
                            <a href="#" @click="changerLangue('AR')">{{ $t('header.languages.arabic') }}</a>
                          </li>
                          <li>
                            <a href="#" @click="changerLangue('FR')">{{ $t('header.languages.french') }}</a>
                          </li>
                          <li>
                            <a href="#" @click="changerLangue('EN')">{{ $t('header.languages.english') }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul> -->
                <ul class="social-links clearfix">
                  <li>
                    <a href="#">
                      <span class="fab fa-facebook-f"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="fab fa-twitter"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="fab fa-linkedin-in"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="fab fa-pinterest-p"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="fab fa-instagram"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Header Upper -->

        <menubar></menubar>
        
        <!--End Header Upper-->

        <!-- Sticky Header  -->
        <div class="sticky-header">
          <div class="auto-container clearfix">
            <!--Logo-->
            <div class="logo pull-left">
              <a href="index.html" title>
                <img src="images/sticky-logo.png" alt title />
              </a>
            </div>
            <!--Right Col-->
            <div class="pull-right">
              <!-- Main Menu -->
              <nav class="main-menu clearfix">
                <!--Keep This Empty / Menu will come through Javascript-->
              </nav>
              <!-- Main Menu End-->
            </div>
          </div>
        </div>
        <!-- End Sticky Menu -->

        <!-- Mobile Menu  -->
        <div class="mobile-menu">
          <div class="menu-backdrop"></div>
          <div class="close-btn">
            <span class="icon flaticon-cancel"></span>
          </div>

          <nav class="menu-box">
            <div class="nav-logo">
              <a href="index.html">
                <img src="images/nav-logo.png" alt title />
              </a>
            </div>
            <div class="menu-outer">
              <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header-->
            </div>
            <!--Social Links-->
            <div class="social-links">
              <ul class="clearfix">
                <li>
                  <a href="#">
                    <span class="fab fa-twitter"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span class="fab fa-facebook-square"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span class="fab fa-pinterest-p"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span class="fab fa-instagram"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span class="fab fa-youtube"></span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <!-- End Mobile Menu -->
      </header>
      <!-- End Main Header -->

      <!-- Banner Section -->
      <section class="banner-section">
        <div
          class="banner-carousel kausid-carousel owl-theme owl-carousel"
          data-options='{"loop": true, "margin": 0, "autoheight": true, "lazyload": true, "nav": true, "dots": true, "autoplay": true, "autoplayTimeout": 6000, "smartSpeed": 300, "responsive": { "0": { "items": 1 }, "768": { "items": 1 }, "1000": { "items": 1 } }}'
        >
          <!-- Slide Item -->
          <div class="slide-item">
            <div class="image-layer" style="background-image: url('assets/images/main-slider/s1.jpg')"></div>

            <div class="auto-container">
              <div class="content-box">
                <div class="content">
                  <div class="inner">
                    <h2>
                      {{ $t('banner.title1') }}
                      <br />{{ $t('banner.title2') }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Slide Item -->
          <div class="slide-item">
            <div class="image-layer" style="background-image:url('assets/images/main-slider/s2.jpg')"></div>

            <div class="auto-container">
              <div class="content-box">
                <div class="content">
                  <div class="inner">
                    <h2>
                      {{ $t('banner.title3') }}
                      <br />{{ $t('banner.title4') }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--End Banner Section -->

      <!--How We Help Section-->
      <section class="how-we-help">
        <div
          class="image-layer"
          style="background-image:url('images/background/parallax-bg-1.jpg')"
        ></div>

        <div class="auto-container">
          <div class="row clearfix">
            <!--Text Column-->
            <div class="text-column col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div class="inner">
                <div class="sec-title light">
                  <div class="sub-title">
                    <!-- <span class="icon"></span> We believe what we achieve -->
                  </div>
                  <h3>{{ $t('about.title') }}</h3>
                  <br>
                  <p>{{ $t('about.description') }}</p>
                </div>
                <div class="info-list">
                  <ul class="clearfix">
                    <li>
                      <div class="icon">
                        <span class="icon fas fa-mosque"></span>
                      </div>
                      <span class="title">{{ $t('gallery.filters.medical') }}</span>
                    </li>
                    <li>
                      <div class="icon">
                        <span class="icon fas fa-tint"></span>
                      </div>
                      <span class="title">{{ $t('gallery.filters.shelter') }}</span>
                    </li>
                    <li>
                      <div class="icon">
                        <span class="icon fas fa-hand-holding-heart"></span>
                      </div>
                      <span class="title">{{ $t('gallery.filters.donation') }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!--News Column-->
            <div class="news-column col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div class="inner">
                <section>   
                  <h3>{{ $t('about.origin.title') }}</h3>
                  <ul class="custom-list">
                    <li v-for="(item, index) in $t('about.origin.items')" :key="'origin-'+index">{{ item }}</li>
                  </ul>
                  
                  <h3>{{ $t('about.mission.title') }}</h3>
                  <ul class="custom-list">
                    <li v-for="(item, index) in $t('about.mission.items')" :key="'mission-'+index">{{ item }}</li>
                  </ul>
                  
                  <h3>{{ $t('about.vision.title') }}</h3>
                  <ul class="custom-list">
                    <li v-for="(item, index) in $t('about.vision.items')" :key="'vision-'+index">{{ item }}</li>
                  </ul>

                  <p>
                    <!-- Cette association est un modèle d'entraide et de coopération pour répondre aux besoins des communautés marginalisées tout en promouvant des valeurs universelles de respect et de justice. -->
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--About Section-->
      <section class="about-section">
        <div class="auto-container">
          <div class="row clearfix">
            <!--Left Column-->
            <div class="left-column col-lg-7 col-md-12 col-sm-12">
              <div class="inner">
                <div class="sec-title">
                  <div class="sub-title">
                    <span class="icon"></span> 
                  </div>
                  <h2>{{ $t('objectives.title') }}</h2>
                </div>
                <div class="">
                  <div style="display: flex; justify-content: space-between;">
                    <ul>
                      <li v-for="(item, index) in $t('objectives.items').slice(0, 3)" :key="'objective-'+index">
                        <strong>{{ item.title }} :</strong><br>
                        {{ item.description }}
                      </li>
                    </ul>

                    <ul>
                      <li v-for="(item, index) in $t('objectives.items').slice(3)" :key="'objective-'+(index+3)">
                        <strong>{{ item.title }} :</strong><br>
                        {{ item.description }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!--Right Column-->
            <div class="right-column col-lg-5 col-md-12 col-sm-12">
              <div class="about-feature-box">
                <div class="outer clearfix">
                  <!--About Feature-->
                  <div class="about-feature col-md-6 col-sm-12" v-for="(item, index) in $t('objectives.items')" :key="'feature-'+index" v-if="index !== 4">
                    <div class="inner-box">
                      <div class="content-box">
                        <div class="inner">
                          <h3>
                            <a href="#">{{ item.title }}</a>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--Adopt Child Section-->
      <section class="adopt-child">
        <div
          class="image-layer"
          style="background-image:url('images/background/adopt-child-bg.jpg')"
        ></div>

        <div class="auto-container">
          <div class="sec-title light">
            <div class="row clearfix">
              <div class="col-lg-5 col-md-12 col-sm-12">
                <div class="sub-title">
                  <span class="icon"></span>
                </div>
                <h2>{{ $t('achievements.title') }}</h2>
              </div>
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="text"></div>
              </div>
            </div>
          </div>

          <!--Carousel-->
          <realisation></realisation>
        </div>
      </section>

      <!-- Galerie 1 -->
      <section class="gallery-section">
        <div class="auto-container">
          <div class="row clearfix">
            <div class="title-column col-xl-6 col-lg-12 col-md-12">
              <div class="sec-title">
                <div class="sub-title"><span class="icon"></span></div>
                <h2>{{ $t('gallery.title1') }}</h2>
              </div>
            </div>
            <div class="filters-column col-xl-6 col-lg-12 col-md-12">
              <div class="filters text-center clearfix">
                <ul class="filter-tabs filter-btns clearfix">
                  <li v-for="filter in gallery1Filters" :key="filter.value"
                      :class="{ active: activeFilter1 === filter.value }"
                      @click="activeFilter1 = filter.value">
                    <span :class="filter.icon"></span>
                    <span class="txt">{{ $t('gallery.filters.' + filter.value) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="items-container row clearfix">
            <div v-for="image in filteredGallery1" :key="image.src"
                 :class="['gallery-item', 'masonry-item', image.category, 'col-lg-4', 'col-md-6', 'col-sm-12']">
              <div class="inner-box">
                <figure class="image-box">
                  <img :src="image.src" :alt="image.alt">
                  <a :href="image.src" class="icon lightbox-image" data-fancybox="gallery1">
                    <span class="fa fa-search-plus"></span>
                  </a>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Galerie 2 -->
      <section class="gallery-section">
        <div class="auto-container">
          <div class="row clearfix">
            <div class="title-column col-xl-6 col-lg-12 col-md-12">
              <div class="sec-title">
                <div class="sub-title"><span class="icon"></span></div>
                <h2>{{ $t('gallery.title2') }}</h2>
              </div>
            </div>
            <div class="filters-column col-xl-6 col-lg-12 col-md-12">
              <div class="filters text-center clearfix">
                <ul class="filter-tabs filter-btns clearfix">
                  <li v-for="filter in gallery2Filters" :key="filter.value"
                      :class="{ active: activeFilter2 === filter.value }"
                      @click="activeFilter2 = filter.value">
                    <span :class="filter.icon"></span>
                    <span class="txt">{{ $t('gallery.filters.' + filter.value) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="items-container row clearfix">
            <div v-for="image in filteredGallery2" :key="image.src"
                 :class="['gallery-item', 'masonry-item', image.category, 'col-lg-4', 'col-md-6', 'col-sm-12']">
              <div class="inner-box">
                <figure class="image-box">
                  <img :src="image.src" :alt="image.alt">
                  <a :href="image.src" class="icon lightbox-image" data-fancybox="gallery2">
                    <span class="fa fa-search-plus"></span>
                  </a>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--Team Section-->
      <section class="team-section">
        <div
          class="icon-one paroller"
          data-paroller-factor="-0.20"
          data-paroller-factor-lg="-0.20"
          data-paroller-factor-sm="-0.10"
          data-paroller-type="foreground"
          data-paroller-direction="horizontal"
        >
          <span class="flaticon-tshirt"></span>
        </div>

        <div class="auto-container">
          <div class="sec-title centered">
            <div class="upper-icon"></div>
            <h2>{{ $t('leaders.title') }}</h2>
            <!-- <div class="text">We believe what we achieve</div> -->
          </div>

          <div class="carousel-box">
            <div
              class="kausid-carousel owl-theme owl-carousel"
              data-options='{"loop": true, "margin": 30, "autoheight": true, "lazyload": true, "nav": true, "dots": true, "autoplay": true, "autoplayTimeout": 6000, "smartSpeed": 300, "responsive": { "0": { "items": 1 }, "600": { "items": 1 }, "768": { "items": 2 }, "800": { "items": 2 }, "1024": { "items": 3 } }}'
            >
              <!--Team Block-->
              <div class="team-block" v-for="(member, index) in $t('leaders.members')" :key="'member-'+index">
                <div class="inner-box">
                  <figure class="image-box">
                    <a href="#">
                      <img v-bind:src="member.photo" alt />
                    </a>
                  </figure>
                  <h3>
                    <a href="#">{{ member.name }}</a>
                  </h3>
                  <div class="designation">{{ member.position }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--Contact Section-->
      <section class="contact-section">
        <div
          class="icon-one paroller"
          data-paroller-factor="-0.20"
          data-paroller-factor-lg="-0.20"
          data-paroller-factor-sm="-0.10"
          data-paroller-type="foreground"
          data-paroller-direction="horizontal"
        >
          <span class="flaticon-heart-2"></span>
        </div>

        <div
          class="icon-two paroller"
          data-paroller-factor="0.20"
          data-paroller-factor-lg="0.15"
          data-paroller-factor-sm="0.10"
          data-paroller-type="foreground"
          data-paroller-direction="horizontal"
        >
          <span class="flaticon-heart-2"></span>
        </div>

        <div
          class="icon-three paroller"
          data-paroller-factor="-0.10"
          data-paroller-factor-lg="-0.15"
          data-paroller-factor-sm="0.10"
          data-paroller-type="foreground"
          data-paroller-direction="horizontal"
        >
          <span class="flaticon-dove"></span>
        </div>

        <div class="auto-container">
          <div class="sec-title centered">
            <div class="upper-icon"></div>
            <h2>{{ $t('contact.title') }}</h2>
          </div>
          <div class="row clearfix">
            <!--Form Column--->
            <div class="form-column col-xl-7 col-lg-12 col-md-12 col-sm-12">
              <div class="inner">
                <div class="shape-box">
                  <h3>{{ $t('contact.subtitle') }}</h3>
                </div>
                <div class="default-form contact-form">
                  <form method="post" action="sendemail.php" id="contact-form">
                    <div class="row clearfix">
                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="field-label">{{ $t('contact.form.name') }}</div>
                        <input type="text" name="username" placeholder required />
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="field-label">{{ $t('contact.form.email') }}</div>
                        <input type="email" name="email" placeholder required />
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="field-label">{{ $t('contact.form.phone') }}</div>
                        <input type="text" name="phone" placeholder required />
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="field-label">{{ $t('contact.form.help') }}</div>
                        <input type="text" name="subject" placeholder required />
                      </div>

                      <div class="col-md-12 col-sm-12 form-group">
                        <div class="field-label">{{ $t('contact.form.message') }}</div>
                        <textarea name="message" :placeholder="$t('contact.form.message')"></textarea>
                      </div>

                      <div class="col-md-12 col-sm-12 form-group">
                        <button class="theme-btn btn-style-one" type="submit" name="submit-form">
                          <span class="btn-title">{{ $t('contact.form.submit') }}</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!--Image Column--->
            <div class="image-column col-xl-5 col-lg-12 col-md-12 col-sm-12">
              <div class="inner">
                <div
                  class="icon-1 paroller"
                  data-paroller-factor="-0.30"
                  data-paroller-factor-lg="-0.20"
                  data-paroller-factor-sm="-0.20"
                  data-paroller-type="foreground"
                  data-paroller-direction="vertical"
                ></div>
                <div
                  class="icon-2 paroller"
                  data-paroller-factor="0.30"
                  data-paroller-factor-lg="0.20"
                  data-paroller-factor-sm="0.10"
                  data-paroller-type="foreground"
                  data-paroller-direction="vertical"
                ></div>
                <figure class="image">
                  <img src="images/resource/featured-image-3.jpg" alt />
                </figure>
              </div>
            </div>
          </div>
        </div>

        <div class="sponsors-outer">
          <div class="auto-container">
            <!--Sponsors Carousel-->
            <div
              class="kausid-carousel owl-theme owl-carousel"
              data-options='{"loop": true, "margin": 40, "autoheight": true, "lazyload": true, "nav": true, "dots": true, "autoplay": true, "autoplayTimeout": 6000, "smartSpeed": 300, "responsive": { "0": { "items": 1 }, "600": { "items": 2 }, "768": { "items": 3 }, "800": { "items": 3 }, "1024": { "items": 4 } }}'
            >
              <div class="slide-item">
                <figure class="image-box">
                  <a href="#">
                    <img src="images/clients/1.png" alt />
                  </a>
                </figure>
              </div>
              <div class="slide-item">
                <figure class="image-box">
                  <a href="#">
                    <img src="images/clients/2.png" alt />
                  </a>
                </figure>
              </div>
              <div class="slide-item">
                <figure class="image-box">
                  <a href="#">
                    <img src="images/clients/3.png" alt />
                  </a>
                </figure>
              </div>
              <div class="slide-item">
                <figure class="image-box">
                  <a href="#">
                    <img src="images/clients/4.png" alt />
                  </a>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Main Footer -->
      <footer class="main-footer">
        <div class="image-layer" style="background-image:url('images/background/footer-bg.jpg')"></div>

        <div class="auto-container">
          <!--Widgets Section-->
          <div class="widgets-section">
            <div class="row clearfix">
              <!--Column-->
              <div class="column big-column col-lg-4 col-md-12 col-sm-12">
                <div class="footer-widget logo-widget">
                  <div class="widget-content">
                    <div class="footer-logo">
                      <a href="index.html">
                        <img src="images/footer-logo.png" alt />
                      </a>
                    </div>
                    <ul class="social-links clearfix">
                      <li>
                        <a href="#">
                          <span class="fab fa-facebook-f"></span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span class="fab fa-twitter"></span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span class="fab fa-vimeo-v"></span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span class="fab fa-instagram"></span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span class="fab fa-youtube"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!--Column-->
              <div class="big-column col-lg-12 col-md-12 col-sm-12">
                <div class="row clearfix">
                  <!--Column-->
                  <div class="column col-lg-4 col-md-12 col-sm-12">
                    <div class="footer-widget info-widget">
                      <div class="widget-content">
                        <h3>{{ $t('contact.title') }}</h3>
                        <ul class="contact-info">
                          <li>{{ $t('contact.address') }}</li>
                          <li>
                            <a href="tel:812-070-3692">
                              <span class="fa fa-phone-alt"></span> {{ $t('contact.phone') }}
                            </a>
                          </li>
                          <li>
                            <a href="mailto:associationdaideauxhandicapesh@gmail.com">
                              <span class="fa fa-envelope-open"></span> {{ $t('contact.email') }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <!--Column-->
                  <div class="column col-lg-8 col-md-12 col-sm-12">
                    <div class="footer-widget info-widget">
                      <div class="widget-content">
                        <h3>{{ $t('footer.newsletter.title') }}</h3>
                        <div class="newsletter-form">
                          <form method="post" action="contact.html">
                            <div class="form-group clearfix">
                              <input
                                type="email"
                                name="email"
                                value
                                :placeholder="$t('footer.newsletter.placeholder')"
                                required
                              />
                              <button type="submit" class="theme-btn newsletter-btn">{{ $t('footer.newsletter.button') }}</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom">
          <div class="auto-container">
            <div class="inner">
              <!--Copyright-->
              <div class="copyright">
                {{ $t('footer.copyright') }}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import menubar from "./Menu/menu.vue";
import realisation from "./realisation/realisation.vue";
import mosque_1 from '@/images/gallery/2.jpg';
import mosque_2 from '@/images/gallery/3.jpg';
import mosque_3 from '@/images/gallery/4.jpg';
import mosque_4 from '@/images/gallery/6.jpg';
import mosque_5 from '@/images/gallery/7.jpg';
import mosque_6 from '@/images/gallery/9.jpg';
// forage association
import forage_1 from '@/images/gallery/forage-1.jpg';
import forage_2 from '@/images/gallery/forage-2.jpg';
import forage_3 from '@/images/gallery/forage-3.jpg';
import forage_4 from '@/images/gallery/forage-4.jpg';
import forage_5 from '@/images/gallery/forage-5.jpg';
import forage_6 from '@/images/gallery/forage-5.jpg';

// Dons association 
import dons_1 from '@/images/gallery/dons-1.jpg';
import dons_2 from '@/images/gallery/dons-2.jpg';
import dons_3 from '@/images/gallery/dons-3.jpg';
import dons_4 from '@/images/gallery/dons-4.jpg';
import dons_5 from '@/images/gallery/dons-5.jpg';
import dons_6 from '@/images/gallery/dons-6.jpg';

// puits association
import puit_1 from '@/images/gallery/puit-1.jpg';
import puit_2 from '@/images/gallery/puit-2.jpg';
import puit_3 from '@/images/gallery/puit-3.jpg';
import puit_4 from '@/images/gallery/puit-4.jpg';
import puit_5 from '@/images/gallery/puit-5.jpg';
import puit_6 from '@/images/gallery/puit-6.jpg';

// PARTENARIAT
import p_mosque_1 from '@/images/gallery/mosque-1.jpg';
import p_mosque_2 from '@/images/gallery/mosque-2.jpg';
import p_mosque_3 from '@/images/gallery/p_mosquee_3.jpg';
import p_mosque_4 from '@/images/gallery/p_mosquee_4.jpg';
import p_mosque_5 from '@/images/gallery/p_mosquee_5.jpg';
import p_mosque_6 from '@/images/gallery/p_mosquee_6.jpg';

// Forage
import p_forage_1 from '@/images/gallery/p_forage_1.jpg';
import p_forage_2 from '@/images/gallery/p_forage_2.jpg';
import p_forage_3 from '@/images/gallery/p_forage_3.jpg';
import p_forage_4 from '@/images/gallery/p_forage_4.jpg';
import p_forage_5 from '@/images/gallery/p_forage_5.jpg';
import p_forage_6 from '@/images/gallery/p_forage_6.jpg';

// dons
import p_dons_1 from '@/images/gallery/p_dons_1.jpg';
import p_dons_2 from '@/images/gallery/p_dons_2.jpg';
import p_dons_3 from '@/images/gallery/p_dons_3.jpg';
import p_dons_4 from '@/images/gallery/p_dons_4.jpg';
import p_dons_5 from '@/images/gallery/p_dons_5.jpg';
import p_dons_6 from '@/images/gallery/p_dons_6.jpg';

// dons
import p_puit_1 from '@/images/gallery/p_puit_1.jpg';
import p_puit_2 from '@/images/gallery/p_puit_2.jpg';
import p_puit_3 from '@/images/gallery/p_puit_3.jpg';
import p_puit_4 from '@/images/gallery/p_puit_4.jpg';
import p_puit_5 from '@/images/gallery/p_puit_5.jpg';
import p_puit_6 from '@/images/gallery/p_puit_6.jpg';


export default {
  name: "HomeView",
  components: {
    HelloWorld,menubar,realisation
  },
  data() {
    return {
      activeFilter1: 'all',
      activeFilter2: 'all',
      langue: "",

      gallery1Filters: [
        { value: 'all', label: 'all', icon: 'icon fas fa-globe' },
        { value: 'medical', label: 'medical', icon: 'icon fas fa-mosque' },
        { value: 'shelter', label: 'shelter', icon: 'icon fas fa-tint' },
        { value: 'donation', label: 'donation', icon: 'icon fas fa-hand-holding-heart' },
        { value: 'well', label: 'well', icon: 'icon fas fa-water' },
      ],
      gallery2Filters: [
        { value: 'all', label: 'all', icon: 'icon fas fa-globe' },
        { value: 'mosque', label: 'mosque', icon: 'icon fas fa-mosque' },
        { value: 'water', label: 'water', icon: 'icon fas fa-tint' },
        { value: 'donation', label: 'donation', icon: 'icon fas fa-hand-holding-heart' },
        { value: 'well', label: 'well', icon: 'icon fas fa-water' },
      ],
      gallery1Images: [ 
        { src: mosque_1, alt: 'Mosquée', category: 'medical' },
        { src: mosque_2, alt: 'Mosquée', category: 'medical' },
        { src: mosque_3, alt: 'Mosquée', category: 'medical' },
        { src: mosque_4, alt: 'Mosquée', category: 'medical' },
        { src: mosque_5, alt: 'Mosquée', category: 'medical' },
        { src: mosque_6, alt: 'Mosquée', category: 'medical' },
        { src: forage_1, alt: 'Forage', category: 'shelter' },
        { src: forage_2, alt: 'Forage', category: 'shelter' },
        { src: forage_3, alt: 'Forage', category: 'shelter' },
        { src: forage_4, alt: 'Forage', category: 'shelter' },
        { src: forage_5, alt: 'Forage', category: 'shelter' },
        { src: forage_6, alt: 'Forage', category: 'shelter' },
        { src: dons_1, alt: 'Don', category: 'donation' },
        { src: dons_2, alt: 'Don', category: 'donation' },
        { src: dons_3, alt: 'Don', category: 'donation' },
        { src: dons_4, alt: 'Don', category: 'donation' },
        { src: dons_5, alt: 'Don', category: 'donation' },
        { src: dons_6, alt: 'Don', category: 'donation' },
        { src: puit_1, alt: 'Puit', category: 'well' },
        { src: puit_2, alt: 'Puit', category: 'well' },
        { src: puit_3, alt: 'Puit', category: 'well' },
        { src: puit_4, alt: 'Puit', category: 'well' },
        { src: puit_5, alt: 'Puit', category: 'well' },
        { src: puit_6, alt: 'Puit', category: 'well' },
      ],
      gallery2Images: [
        { src: p_mosque_1, alt: 'Mosquée', category: 'mosque' },
        { src: p_mosque_2, alt: 'Mosquée', category: 'mosque' },
        { src: p_mosque_3, alt: 'Mosquée', category: 'mosque' },
        { src: p_mosque_4, alt: 'Mosquée', category: 'mosque' },
        { src: p_mosque_5, alt: 'Mosquée', category: 'mosque' },
        { src: p_mosque_6, alt: 'Mosquée', category: 'mosque' },
        { src: p_forage_1, alt: 'water', category: 'water' },
        { src: p_forage_2, alt: 'water', category: 'water' },
        { src: p_forage_3, alt: 'water', category: 'water' },
        { src: p_forage_4, alt: 'water', category: 'water' },
        { src: p_forage_5, alt: 'water', category: 'water' },
        { src: p_forage_6, alt: 'water', category: 'water' },
        { src: p_dons_1, alt: 'donation', category: 'donation' },
        { src: p_dons_2, alt: 'donation', category: 'donation' },
        { src: p_dons_3, alt: 'donation', category: 'donation' },
        { src: p_dons_4, alt: 'donation', category: 'donation' },
        { src: p_dons_5, alt: 'donation', category: 'donation' },
        { src: p_dons_6, alt: 'donation', category: 'donation' },
        { src: p_puit_1, alt: 'well', category: 'well' },
        { src: p_puit_2, alt: 'well', category: 'well' },
        { src: p_puit_3, alt: 'well', category: 'well' },
        { src: p_puit_4, alt: 'well', category: 'well' },
        { src: p_puit_5, alt: 'well', category: 'well' },
        { src: p_puit_6, alt: 'well', category: 'well' },
       
      ],
    };
  },
  computed: {
    filteredGallery1() {
      if (this.activeFilter1 === 'all') return this.gallery1Images;
      return this.gallery1Images.filter(img => img.category === this.activeFilter1);
    },
    filteredGallery2() {
      if (this.activeFilter2 === 'all') return this.gallery2Images;
      return this.gallery2Images.filter(img => img.category === this.activeFilter2);
    },
    direction() {
      return this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
    }
  },
  created() {
  }, 
  mounted() {
    this.langue = this.$i18n.locale;
    console.log(this.langue)
  },
  methods: {
    changerLangue(langue) {
      localStorage.setItem("langue", langue);
      window.location.reload();
    },
  },
};
</script>

<style>
.custom-list li {
  position: relative;
  padding-left: 25px;
}

.custom-list li::before {
  content: ".";
  color: black;
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: -3px;
}

.gallery-section .filter-tabs {
  margin-bottom: 20px;
}

.gallery-section .filter-tabs li {
  display: inline-block;
  margin: 0 10px;
  cursor: pointer;
}

.gallery-section .filter-tabs li.active {
  font-weight: bold;
  color: #000;
}

.gallery-section .gallery-item {
  margin-bottom: 20px;
}

.gallery-section .image-box img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.gallery-section .image-box a {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-section .image-box:hover a {
  opacity: 1;
}


</style>